function isPlainObject(value) {
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

export function removeVersionAttributesFromJsonPayload(value) {
  if (Array.isArray(value)) {
    return value.map((item) => removeVersionAttributesFromJsonPayload(item));
  }

  if (!isPlainObject(value)) {
    return value;
  }

  return Object.entries(value).reduce((acc, [key, entryValue]) => {
    if (key === "version") {
      return acc;
    }

    acc[key] = removeVersionAttributesFromJsonPayload(entryValue);
    return acc;
  }, {});
}
